






import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { Zakazka } from '@/modules/servis/zakazka';
import { PageMode } from '@/main/utils/pageMode';
import { createButton } from '@/main/utils/tableOperations';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	computed: {
		extraButtons() {
			return {
				...createButton((event, cells) => { this.createMdvZakazka(cells); }),
			};
		},
	},
	methods: {
		// Don't load filter.
		async loadData() {
			const schema = await this.schema();
			if(schema.message !== undefined)
			{
				return;	
			}
			await Promise.all([schema, this.tableData()]);
		},
		createMdvZakazka(rowCells: any) {
			const PnvId = rowCells[this.table.cellNames!.PNV_ID];
			const NvskladId = rowCells[this.table.cellNames!.NVSKLAD_ID];
			openEdit(Zakazka.name, PageMode.CREATE, {
				filter: {
					ZakazkaDruh: 'P',
					OtevrenePrp: true,
					PnvId,
					NvskladId,
				},
			});
		},
	},
});
